import { render } from "./Formateurs.vue?vue&type=template&id=e7bf9ece"
import script from "./Formateurs.vue?vue&type=script&lang=js"
export * from "./Formateurs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__